import type { ReactNode } from 'react';
import styles from './Alert.module.css';

export type AlertLevel = 'info' | 'warning' | 'success' | 'danger';

interface Props {
    level?: AlertLevel;
    spinner?: boolean;
    children: ReactNode;
    id?: string;
}

export function Alert({ level = 'info', spinner = false, children, id }: Props) {
    return (
        <div id={id} className={`${styles.alert} ${styles[level]}`} role={level === 'danger' ? 'alert' : 'status'}>
            {spinner && <span className={styles.spinner} aria-hidden="true" />}
            <span>{children}</span>
        </div>
    );
}
